import { cn } from "@/lib/utils";
import type { PropsWithChildren } from "react";

interface EmptyStateProps extends PropsWithChildren {
  icon: React.ComponentType<{ className: string }>;
  title: string;
  description?: string;
  className?: string;
}

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  children,
  className,
}: EmptyStateProps) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center py-12 px-4 border-2 border-dashed dark:border-white/10 rounded-lg",
        className,
      )}
    >
      <div className="p-4 bg-muted rounded-full mb-4">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      {description && (
        <p
          className={cn(
            "text-muted-foreground text-center max-w-sm",
            children && "mb-4",
          )}
        >
          {description}
        </p>
      )}
      {children}
    </div>
  );
};
